import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68b817c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b817c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b817c4')) {
      api.createRecord('68b817c4', component.options)
    } else {
      api.reload('68b817c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68b817c4&scoped=true&", function () {
      api.rerender('68b817c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/giftProduct/index.vue"
export default component.exports